import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { FormattedMessage } from "react-intl";
import GeneralService from '../../apis/GeneralService';
import ApiURL from '../../apis/ApiURL';
import Constants from '../../utility/Constants';
import { useLocation, useNavigate } from 'react-router-dom';
import { listGame, resetListGame } from '../../redux/slices/GameSlice';
import gameLunchHandler from '../../utility/Helpers';

export default function WebFavourites() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigte = useNavigate();

  const languageState = useSelector((state) => state.languageState);
  let languageCode = languageState.active_language.language_code;

  const userDetails = useSelector((state) => state.userDetailState);
  let token = userDetails?.user_details?.token ? userDetails?.user_details?.token : ""
  /* If user not logged in then redirected to home page */
  if (!userDetails.user_details) {
    //window.location.href = "/"
    navigte('/');
  }
  /* ************************************** */
  const userToken = userDetails.user_details ? userDetails.user_details.token : "";
  const gameListObj = useSelector((state) => state.gameState);

  let [loading, setLoading] = useState(true);
  let newPage = 1;
  let [page, setPage] = useState(1);
  let [totalPage, setTotalPage] = useState(1);

  async function getFavouritesGames() {

    let params = JSON.stringify({});

    GeneralService.apiGetCallRequest(ApiURL.getFavouriteGames, params, userToken).then(res => {
      if (res.error == Constants.API_RESPONSE_ERROR_FALSE) {
        dispatch(listGame(res.data.favourite_games))
      }
    }).catch(error => {

    })
  }

  useEffect(() => {
    // if (location.pathname != currentRoute) {
    dispatch(resetListGame())
    // }
  }, [location.pathname])


  useEffect(() => {
    getFavouritesGames()
  }, [])

  const loadMoreClick = () => {
    newPage = page + 1;
    setPage(newPage);
    getFavouritesGames();
  }

  return (
    < >
      {/* provider section start */}
      <div className="slots_sec content_container">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="slots_inn">
                {/* <h6><FormattedMessage id="FAVOURITES" /></h6> */}
                <div className='provider-heading-section'>

                  <span><FormattedMessage id="FAVOURITES" /></span>
                </div>
                <div className='w-100 d-flex'>
                  {
                    gameListObj.game_list?.length > 0 ? gameListObj.game_list.map((gameData, gameIndex) => (
                      <div onClick={() => gameLunchHandler(gameData, languageCode, token)} key={gameIndex}>
                        <div className='each-game-card'>
                          {/* <img className='each-game-card-img' src={Constants.PROVIDERS_WITH_RESIZED_IMAGES.includes(gameData.provider_name) ? gameData.image_file_name.replace('/game/', '/250x250/') : gameData.image_file_name} alt='game_card_img' /> */}
                          <img className='each-game-card-img' src={gameData.image_file_name} alt='game_card_img' />
                          <div className='game-detail-section'>
                            <span className='game-detail-playing'>{gameData.game_name[languageCode]}</span>
                            <span className='game-provider-name'>{gameData.provider_name[languageCode]}</span>
                          </div>
                        </div>
                      </div>
                    )) : ""
                  }

                  {
                    (loading == false && gameListObj.game_list.length == 0) ?
                      <div className="alert alert-primary no_game_found" role="alert">
                        <FormattedMessage id='NOGAMEFOUND' />
                      </div> : ""
                  }
                </div>
              </div>

              {(totalPage == page) ? "" :
                <div className='load_more_button_div'>
                  <button className='load_more_button' onClick={loadMoreClick}>
                    <FormattedMessage id='LOADMORE' />
                  </button>
                </div>}
            </div>
          </div>
        </div>
      </div>
      {/* provider section end */}
    </>
  )
}
